<template>
  <div>
    <div id="index">
      <video
        class="video_box"
        v-if="indexBack.type == '2'"
        :src="indexBack.video"
        autoplay
        loop
        muted
      ></video>
      <img
        :src="indexBack.image"
        v-if="indexBack.type == '1'"
        class="backImg_box"
        alt=""
      />
      <div class="content_box">
        <div class="content_center_box">
          <div
            class="tianutuan_box"
            @click="totianyuan"
            @mouseenter="tianutuanEnter"
            @mouseleave="tianutuanLeave"
          >
            <img
              :class="tianYuanFlag ? 'tianyuan' : 'tianyuan_1'"
              :src="tianY_Img"
              alt=""
            />
          </div>

          <div
            class="floor_box"
            @click="tofloor"
            @mouseenter="FloorEnterr"
            @mouseleave="FloorLeaver"
          >
            <img
              :class="floorFlag ? 'floor' : 'floor_1'"
              :src="diB_Img"
              alt=""
            />
          </div>
        </div>
        <div
          class="tianutuan_float"
          id="img1"
          style="
            z-index: 1100;
            left: 2px;
            position: absolute;
            top: 43px;
            visibility: visible;
          "
          @click="totianyuan"
          @mouseenter="tianyuanEnter"
          @mouseleave="tianyuanLeace"
        >
          <img
            class="img_cover"
            src="../../assets/indexImg/ad.png"
            alt=""
          />
        </div>
        <div
          class="floor_float"
          id="img2"
          style="
            z-index: 1100;
            right: 2px;
            position: absolute;
            top: 43px;
            visibility: visible;
          "
          @mouseenter="floorEnter"
          @mouseleave="floorLeave"
          @click="tofloor"
        >
          <img
            src="../../assets/indexImg/ad2.png"
            class="img_cover"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { moveimg } from "../../assets/js/move.js";
import { moveimg2 } from "../../assets/js/move1.js";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      indexBackimg: require("../../assets/indexImg/indeximg.png"),
      tianYuanFlag: true,
      floorFlag: true,
      videoUrl: "dsa",
      indexBack: {},
      tianY_Img: require("../../assets/indexImg/tianyuan4.png"),
      diB_Img: require("../../assets/indexImg/floor3.png"),
    };
  },
  methods: {
    FloorEnterr() {
      this.diB_Img = require("../../assets/indexImg/qldb (2).png");
      this.floorFlag = false;
    },
    FloorLeaver() {
      this.diB_Img = require("../../assets/indexImg/floor3.png");
      this.floorFlag = true;
    },
    tianyuanEnter() {
      this.$store.commit("setMoveOne", true);
    },
    tianyuanLeace() {
      this.$store.commit("setMoveOne", false);
    },
    //点击去天原管道
    totianyuan() {
      this.$router.push("/TianYuanHome");
    },
    //点击去地板
    tofloor() {
      this.$router.push("/FloorHome");
    },
    floorEnter() {
      this.$store.commit("setMoveTwo", true);
    },
    floorLeave() {
      this.$store.commit("setMoveTwo", false);
    },
    tianutuanEnter() {
      this.tianYuanFlag = false;
      this.tianY_Img = require("../../assets/indexImg/tygd (2).png");
    },
    tianutuanLeave() {
      this.tianYuanFlag = true;
      this.tianY_Img = require("../../assets/indexImg/tianyuan3.png");
    },
  },
  mounted() {
    if (this.baclgroundInfo.length === 0) {
      setTimeout(() => {
        var obj = this.baclgroundInfo;
        this.indexBack = obj[0];
      }, 500);
    } else {
      var obj = this.baclgroundInfo;
      this.indexBack = obj[0];
    }
    var img1 = document.getElementById("img1");
    var img2 = document.getElementById("img2");
    moveimg(img1, true);
    moveimg2(img2, true);
  },
  computed: {
    baclgroundInfo() {
      return this.$store.state.baclgroundInfo;
    },
    setMoveOne() {
      return this.$store.state.moveOne;
    },
    setMoveTwo() {
      return this.$srore.state.MoveTwo;
    },
  },
};
</script>


<style scoped lang='scss'>
#index {
  width: 100vw;
  min-width: 1200px;
  height: 100vh;
  overflow: hidden !important;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  .video_box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    width: 100vw;
    height: 100%;
  }
  .backImg_box {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .content_box {
    z-index: 2;
    background: transparent;
    min-width: 1200px !important;
    // width: 80%;
    position: relative;
    .content_center_box {
      width: 75.5vw;
      height: 100vh;
      min-width: 1200px !important;
      display: flex;
      justify-content: space-around;
      margin: 0 auto;
      align-items: center;
      .tianutuan_box {
        // position: absolute;
        // left: 235px;
        // top: 447px;
        cursor: url("../../assets/cursor.png"), auto;
        margin-top: 9.5px;
        // border: 1px solid red;
        img {
          width: 100%;
          height: 100%;
          // border: 1px solid red;
        }
        .tianyuan_1 {
          // width: 441px;
          width: 516px;
          // height: 160px;
          height: 16vh;
          object-fit: contain;
          animation: tianyuan1 1s linear;
        }
        // @keyframes tianyuan1 {
        //   0% {
        //     opacity: 0;
        //   }
        //   100% {
        //     opacity: 1;
        //   }
        // }
        .tianyuan {
          // width: 441px;
           width: 516px;
          // height: 160px;
          height: 16vh;
          object-fit: contain;
          animation: tianyuan 1s linear;
        }
        // @keyframes tianyuan {
        //   0% {
        //     opacity: 0;
        //   }
        //   100% {
        //     opacity: 1;
        //   }
        // }
      }
      .floor_box {
        // position: absolute;
        // right: 272px;
        // top: 447px;
        cursor: url("../../assets/cursor.png"), auto;
        // border: 1px solid red;

        .floor_1 {
          width: 441px;
          // height: 150px;
          height: 15vh;
          object-fit: contain;
          animation: floor1 1s linear;
        }
        // @keyframes floor1 {
        //   0% {
        //     opacity: 0;
        //   }
        //   100% {
        //     opacity: 1;
        //   }
        // }
        .floor {
          width: 441px;
           height: 14.8vh;
          object-fit: contain;
          animation: floor 1s linear;
        }
        // @keyframes floor {
        //   0% {
        //     opacity: 0;
        //   }
        //   100% {
        //     opacity: 1;
        //   }
        // }
      }
    }

    .tianutuan_float {
      width: 314px;
      height: 159px;
      animation: mytianyuan 20s linear infinite;
    }

    @keyframes mytianyuan {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .floor_float {
      width: 278px;
      height: 270px;
      animation: myfloor 20s linear infinite;
    }
    @keyframes myfloor {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>